import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import Input from '@material-ui/core/Input';
import classNames from "classnames";
import { Grid, ListItem } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typography from '../../components/CustomTypo';
import { LinkRouter } from '../../components/Link';
import 'react-phone-input-2/lib/style.css'
import SocialComponent from '../../components/SocialComponent';
import { domainName, portal_config } from '../../../portal.config';
import InfiniteScroll from 'react-infinite-scroll-component';
import CustomizedCircularProgress from '../../components/CircularProgress';
import { getLogo } from '../../utils/common';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { GiftIcon, PhoneIcon } from '../../components/icons';

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(20),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(4)
    },
    content: {
        marginTop: theme.spacing(8),
       // borderTop: '1px solid',
        //borderColor: theme.palette.border.primary,
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    item: {
        borderTop: '1px solid',
        borderColor: theme.palette.border.primary,
    },
    marginRight: {
        marginRight: theme.spacing(4)
     },
    item_image: {
        width: 48,
        height: 48,
        borderRadius: 48
    },

});
function FavouriteStoreView(props){
    const { classes, t, onShowLoading, showLoadMore, stores } = props;
    return (
        <PublicPage rightComponent={
            <Grid xs={12} sm={12} md={12} item container>
                <Grid xs={12} sm={12} item container>
                    <Typography variant='h2' color={portal_config[domainName].publicPagePrimaryColor ? 'onPrimary' : 'primary'} mg_bottom_md>{t('prefered_rewards')}</Typography>
                </Grid>
                <Grid xs={12} item container direction="row">
                    <Typography variant='body2' color={portal_config[domainName].publicPagePrimaryColor ? 'onPrimary' : 'primary'} center>{t('select_favourite_store_desc')}&nbsp;</Typography>
                </Grid>

                <Grid xs={12} sm={12} item container justify='center' className={classes.content} >
                    <InfiniteScroll
                        dataLength={stores.length} //This is important field to render the next data
                        // next={handleLoadMore}
                        // hasMore={hasMore}
                        // loader={showLoadMore ? <CustomizedCircularProgress /> : <h4>{""}</h4>}
                        height={400}
                        //style={{ backgroundColor: '#000' }}
                    >
                        <Grid xs={12} item container>
                            {stores.map((item, index) => <FavouriteItem classes={classes} key={index}
                                item={item}
                                onSelectStore={props.onSelectStore}/>
                            )}
                        </Grid>
                    </InfiniteScroll>

                    <Grid xs={12} item container justifyContent='flex-end' className={classes.marginTop}>
                        <LinkRouter onClick={props.onSkip} variant='h6' size='lg' color={portal_config[domainName].publicPagePrimaryColor ? null : 'primary'}>{t('skip')}</LinkRouter>
                    </Grid>
                </Grid>
            </Grid>
        } />
    );
}


function MerchantImage(props) {
    var image = props.image;
    var classes = props.classes
    if (image) {
        return <img src={image.url} className={classes.item_image} />
    } else {
        return <GiftIcon />
    }
}

function FavouriteItem(props) {
    const { item, classes } = props
    var phone = dataUtil.filterContactPreferencesByType(item.contact_info, "PHONE");
    var location = item.locations && item.locations.length > 0 ? item.locations[0] : null;
    return (
        <Grid xs={12} item onClick={() => props.onSelectStore(item)} className={classes.item} style={{ cursor: 'pointer' }} data-favourite-id={item.id} data-favourite-name={item.name}>
            <ListItem item xs={12} container  >
                <Grid item className={classes.marginRight}>
                    <MerchantImage image={dataUtil.getImageByUsageType(item.creatives, usage_type.offer_map_merchant)} classes={classes}/>
                </Grid>
                <Grid item >
                    <Typography variant='subtitle2'>{item.name}</Typography>
                    {location ? <Typography variant='body2'>{location.address_line_1}</Typography> : null}
                    <Grid item style={{ marginTop: 4}}>
                        {phone && <Grid item direction='row' container>
                            <PhoneIcon /><Typography mg_left_sm variant='body1'>{phone.value}</Typography>
                        </Grid>}
                    </Grid>
                </Grid>
            </ListItem>

        </Grid>
    )
}
export default withStyles(styles)(withTranslation()(FavouriteStoreView));